import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 11, fontFamily: "Helvetica", color: "#101828" },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: { flexDirection: "row", justifyContent: "space-between", marginBottom: 4, fontSize: 10 },
  label: { color: "#344054", fontWeight: "bold", width: "50%" },
  value: { color: "#101828", width: "50%", textAlign: "right" },
  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#003149",
    marginBottom: 6,
    marginTop: 8,
  },
});

const ExportTaskAttendanceHistoryPDF = ({ data, logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}

        <Text style={styles.heading}>
          {t("taskAttendanceHistory.heading")}
        </Text>

        {data.map((row, i) => (
          <View key={i} style={styles.recordGroup}>
            <Text style={styles.sectionTitle}>Worker Information</Text>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.workerName")}:</Text>
              <Text style={styles.value}>{row.workerName || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.workerEmail")}:</Text>
              <Text style={styles.value}>{row.workerEmail || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.department")}:</Text>
              <Text style={styles.value}>{row.workerDepartment || "--"}</Text>
            </View>

            <Text style={styles.sectionTitle}>Task Information</Text>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.taskName")}:</Text>
              <Text style={styles.value}>{row.taskName || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.date")}:</Text>
              <Text style={styles.value}>{row.date || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.taskLocation")}:</Text>
              <Text style={styles.value}>{row.taskLocation || "--"}</Text>
            </View>

            <Text style={styles.sectionTitle}>Start Information</Text>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.scheduledStart")}:</Text>
              <Text style={styles.value}>{row.scheduledStartTime || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.actualStart")}:</Text>
              <Text style={styles.value}>{row.actualStartTime || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.startStatus")}:</Text>
              <Text style={styles.value}>{row.startStatus || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.startDelay")}:</Text>
              <Text style={styles.value}>{row.startDelay || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.startLocationValidated")}:</Text>
              <Text style={styles.value}>
                {row.startLocationValidated !== undefined ? (row.startLocationValidated ? "Yes" : "No") : "--"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.startDistance")}:</Text>
              <Text style={styles.value}>
                {row.startDistanceM !== null && row.startDistanceM !== undefined ? `${Number(row.startDistanceM).toFixed(1)}m` : "--"}
              </Text>
            </View>

            <Text style={styles.sectionTitle}>End Information</Text>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.scheduledEnd")}:</Text>
              <Text style={styles.value}>{row.scheduledEndTime || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.actualEnd")}:</Text>
              <Text style={styles.value}>{row.actualEndTime || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.endStatus")}:</Text>
              <Text style={styles.value}>{row.endStatus || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.endDelay")}:</Text>
              <Text style={styles.value}>{row.endDelay || "--"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.endLocationValidated")}:</Text>
              <Text style={styles.value}>
                {row.endLocationValidated !== undefined ? (row.endLocationValidated ? "Yes" : "No") : "--"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("taskAttendanceHistory.tableHeaders.endDistance")}:</Text>
              <Text style={styles.value}>
                {row.endDistanceM !== null && row.endDistanceM !== undefined ? `${Number(row.endDistanceM).toFixed(1)}m` : "--"}
              </Text>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  );
};

export default ExportTaskAttendanceHistoryPDF;
